import { Eyebrow, MaskLines, Reveal } from "./ui-bits";

const Intro = () => (
  <section id="about" className="bg-ivory text-obsidian" data-testid="intro-section">
    <div className="mx-auto grid max-w-[1440px] gap-10 px-5 py-24 md:grid-cols-12 md:px-10 md:py-40">
      <div className="md:col-span-3">
        <Eyebrow tone="dark">01 / Our Approach</Eyebrow>
      </div>
      <div className="md:col-span-9">
        <h2 className="font-serif text-4xl leading-[1.02] tracking-[-0.01em] sm:text-5xl lg:text-6xl">
          <MaskLines
            lines={[
              "COMMERCIAL REAL ESTATE,",
              <span key="i" className="italic">WITHOUT THE NOISE.</span>,
            ]}
          />
        </h2>
        <Reveal delay={0.25} className="mt-10 max-w-xl">
          <p className="text-sm leading-relaxed text-obsidian/70 md:text-base">
            Elevate Estates helps businesses and property owners make smarter
            decisions about commercial space. From high-street retail and F&B
            locations to corporate offices and commercial assets, we combine
            local market intelligence, relationships and technology to simplify
            the entire real-estate journey.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Intro;
